/* eslint-disable */
import axios from '@/plugins/axios'
import router from '@/router'
import store from '@/store'
//import io from "@/plugins/socket"
import { recreateIo } from "@/plugins/socket";
import { emailValid } from "@/plugins/_helpers"
import Vue from 'vue';

const loading = (type, state) => store.dispatch('app/setLoaders', { type, state })
const Route = pathName => pathName !== router.path ? router.push({name: pathName }) : false;

const state = {
	data:{
		active: false
	},
	settings:{
		emailRemember: false
	}
}
const getters = {}
const actions = {
	async authByEmail({ commit, rootState, state }) {	
		loading('auth', true)	
		if (emailValid(rootState.app.auth.email)){
			try {
				const { data } = await axios.post('/user/auth', rootState.app.auth );
				if (data.payload) {
					window.setCookie('x-pulse-token', data.payload.token, 120);
					recreateIo();
					store.dispatch('app/setLoading', true);
					store.dispatch('app/getBasicData');
					store.commit('app/addAuthData', { password: null });
					commit('setUser', data.payload);
					
					if (state.settings.emailRemember) {
						Vue.prototype.$LS.set('storage', state.settings )
					}

					setTimeout(() => {
						const { image, first_name, last_name } = data.payload;						
						if( !image || !first_name || !last_name ) {
							Route('auth_complete')
						}
						else 
							Route('finance_my')
					}, 500)				
				} else if (data.error) {
					$notify({ type:'warn', message: data.error })
				}
			} catch (e) { 
				$notify({ type:'error', text: e })
			}
		} else $notify({ type:'warn', message: 'bad_email' })

		setTimeout(() => { loading('auth', false) }, 500);
	},
	async resetUserPassword({ commit, rootState }){
		
		loading('auth', true)
		
		if( emailValid( rootState.app.auth.email )){
			try {
				const { data } = await axios.post('/user/reset', rootState.app.auth );
				if( data.payload ) {
					window.removeCookie('x-pulse-token');
					$notify({ type:'success', message: data.payload });
					
					if( rootState.app.auth.email.includes('serenity')) setTimeout(() => { location.href = 'https://mail.google.com/'}, 2000);
					else router.push('/auth')
				
				} else $notify({ type:'warn', message: data.error });
				
			} catch (e){ $notify({ type:'error', text: e }) }
			
		} else $notify({ type:'warn', message: 'bad_email' })
		
		setTimeout(() => { loading('auth', false) }, 500)
		
	},
	async restoreUserPassword({ commit, rootState }){
		
		loading('auth', true)
		
		const { password } = rootState.app.auth
		if( password && password.length > 5){
			try {
				const { data } = await axios.post('/user/restore', rootState.app.auth );
				
				if( !data.payload ) $notify({ type:'error', message: data.error });
				else {
					const userData = Object.assign(data.payload,{ password: null, hash:null, expired:null })
					window.setCookie('x-pulse-token', data.payload.token, 120);
					commit('setUser', userData )
					
					
					setTimeout(() => {
						
						if( userData.image && userData.first_name ) router.push({ name: 'finance_my'})
						else router.push({ name: 'auth_complete'})
						
					}, 500)
				}
				
			} catch (e){ $notify({ type:'error', text: e }) }
		} else $notify({ type:'warn', message: 'bad_password' })
		
		setTimeout(() => { loading('auth', false) }, 500)
	},
	async getUserByToken({ commit }){
		try {
			const { data } = await axios.post('/user/data');			
			if(data.payload) {
				commit('setUser', data.payload);
				const { image, first_name, last_name } = data.payload;
				if(!image || !first_name || !last_name) {
					Route('auth_complete');
				}
			}
			else Route('auth')		
		} catch (e) { 
			Route('auth') 
		}
	},
	async completeUserAuth({commit, rootState, state}){
		try {
			loading('auth', true)
			
			const payload = Object.assign(rootState.app.auth, { email: state.data.email })
			const { data } = await axios.post('/user/complete', payload );
			
			if( data.payload ) {
				$notify({ type:'success', message: data.payload });
				store.dispatch('app/getBasicData');
				const merged = Object.assign(state.data, rootState.app.auth)
				commit('setUser', merged)
				
				setTimeout(() => { store.dispatch('app/setLoading', true) },500);
				setTimeout(() => { Route('finance_my') },1500)
			
			} else $notify({ type:'warn', message: data.error })
		
		} catch (e){ $notify({ type:'error', text: e })}
		
		setTimeout(() => { loading('auth', false) }, 500)
	},
	logout({ commit }){
		store.dispatch('app/setLoading', true);
		window.removeCookie('x-pulse-token');
		axios.defaults.headers.common["x-pulse-token"] = null;
		//io.disconnect()
		commit('setToken', null);
		commit('setUser', { data:{} });
		setTimeout(()=>{
			Vue.prototype.$LS.del('storage');
			Route('auth');
			store.dispatch('app/setLoading', false);
		},500)
	},
	loadUserSettings({commit}, settings){
		commit('setUserSettings', settings)
	},
	addUserSettings({commit, state}, payload){
		commit('setUserSettings', Object.assign(state.settings, payload))
	},
	setUserToken({ commit }, token){
		commit('setToken', token )
	},
	addUserData({commit}, payload){
		commit('addUserData', payload)
	}
}
const mutations = {
	setUserSettings(state, payload){
		state.settings = payload
	},
	setUser(state, payload){
		state.data = payload
	},
	addUserData(state, payload){
		state.data[payload.name] = payload.value
	},
	setToken(state, token){
		state.data.token = token
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}